import { ConversionsBoostTable } from './conversions-boost-table';

export { ConversionsBoostTable };
